// extracted by mini-css-extract-plugin
module.exports = {"header":"pages-sponsorships-campaigns__header--A6YB_"};